import { useEffect } from "react";
import { motion, animate, useMotionValue, useTransform } from "framer-motion";

interface AnimatedPercentProps {
	value: number;
	delay?: number;
}

export const AnimatedPercent = ({ value, delay = 0.25 }: AnimatedPercentProps) => {
	const safeValue = Math.min(100, Math.max(0, value));

	const motionValue = useMotionValue(0);
	const rounded = useTransform(motionValue, (latest) => {
		return `${Math.round(latest)}%`;
	});

	useEffect(() => {
		const controls = animate(motionValue, safeValue, {
			delay,
			duration: 0.8,
			ease: [0.16, 1, 0.3, 1],
		});
		return controls.stop;
	}, [safeValue]);

	return <motion.span>{rounded}</motion.span>;
};
